import { Constants } from '../app.constants';

export class ErrorUtils {
    private erros: any = {
        "HttpErrorResponse" : {
            "title" : "Ops",
            "description": "Erro de conexão com o servidor"
        }
    };

    /**
     * Metodo que rotorna uma transcrição do erro acusado por uma resição 
     * @param error 
     */
    verifyError(error: any): any{
        return this.erros[error.name];
    }
}